import {
  readNoteHistoryKey,
  TEXT_BOX_SELECTOR,
  type NoteHistoryKeyPress,
} from '@/entities/templates';

type HistoryKeyPress = NoteHistoryKeyPress & Pick<KeyboardEvent, 'target'>;

// The document's undo and redo keys, which a text box keeps for the text
// typed in it: the note's editor sends them to the document itself.
export const readHistoryShortcut = (press: HistoryKeyPress) =>
  press.target instanceof Element && press.target.closest(TEXT_BOX_SELECTOR)
    ? null
    : readNoteHistoryKey(press);
